(function(cfg){
  if (!cfg) return;

  /* ===== helpers ===== */
  const $  = (s, r) => (r||document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r||document).querySelectorAll(s));
  const IS_PRODUCT    = !!cfg.isProduct || cfg.isProduct === 'product';
  const IS_COLLECTION = !!cfg.isCollection || cfg.isCollection === 'collection';
  const IS_SEARCH     = !!cfg.isSearch || cfg.isSearch === 'search';

  // 価格コンテナ（ここを丸ごと "ASK" に差し替え）
  const PRICE_CONTAINER_SEL = [
    '[data-block-type="price"] price-list',
    'price-list',
    '.price','.price__container','.product__price','.product-meta__price','.ProductMeta__Price',
    '.card__price','[data-product-price]'
  ].join(',');

  // 価格の葉ノード（保険）
  const PRICE_LEAF_SEL = [
    '[data-block-type="price"] sale-price',
    '[data-block-type="price"] regular-price',
    'sale-price','regular-price','compare-at-price',
    '.price__regular','.price__sale','.price-item','.price-item--regular','.price-item--sale',
    'span.money'
  ].join(',');

  // 購入UI（Prestige新旧）
  const BUY_BLOCK_SEL  = '[data-block-type="buy_buttons"], buy-buttons';
  const BUY_TARGET_SEL = [
    BUY_BLOCK_SEL,
    'form[action*="/cart/add"]','product-form','.product-form','.product__form',
    'button[type="submit"][form^="product-form"]','button[type="submit"][form*="product-form"]',
    '.shopify-payment-button','shopify-accelerated-checkout'
  ].join(',');

  // コレクションのクイック追加
  const QUICK_ADD_SEL = [
    '.product-card__quick-add-button',
    'quick-buy-modal',
    'product-form'
  ].join(',');

  // プレクローク解除
  function uncloack(){ const st = $('#vn-ask-precloak'); if (st) st.remove(); }

  // mailto URL
  function makeMailtoUrl(to, title, url){
    const subj = (title || '商品の価格') + (cfg.askSuffix || 'の価格について');
    const lines = [
      '【商品名】' + (title || ''),
      '【商品URL】' + (url || location.href),
      '',
      '--- 以下にご質問内容をご記入ください ---'
    ];
    return 'mailto:' + encodeURIComponent(to) +
           '?subject=' + encodeURIComponent(subj) +
           '&body=' + encodeURIComponent(lines.join('\n'));
  }

  /** 価格 → "ASK" */
  function replacePriceWithASK(root=document){
    let changed = false;
    $$(PRICE_CONTAINER_SEL, root).forEach(container=>{
      const cls = (container.firstElementChild && container.firstElementChild.className) || '';
      container.innerHTML = '';
      const span = document.createElement('span');
      span.textContent = 'ASK';
      span.className = (cls || '').toString();
      container.appendChild(span);
      changed = true;
    });
    if (!changed) {
      $$(PRICE_LEAF_SEL, root).forEach(leaf=>{ leaf.textContent = 'ASK'; changed = true; });
    }
    return changed;
  }

  /** 購入UIを無効化（削除＋submitブロック） */
  function disableBuying(root=document, onRedirect){
    $$(BUY_TARGET_SEL, root).forEach(n=>{ try{ n.remove(); }catch(e){ n.style.display='none'; } });
    if (!document.__vnAskSubmitHooked) {
      document.addEventListener('submit', function(ev){
        const f = ev.target;
        if (f && f.matches('form[action*="/cart/add"]')) {
          ev.preventDefault();
          onRedirect && onRedirect();
        }
      }, true);
      document.__vnAskSubmitHooked = true;
    }
  }

  /** Paidy の表示を削除（ASK商品のみ） */
  function hidePaidy(root=document){
    // 1) 表示DOM
    $$('.paidy-promotional-messaging', root).forEach(el=>{ try{ el.remove(); }catch(e){ el.style.display='none'; } });
    // 2) スクリプト
    $$('script[src*="cdn.paidy.com"], script[src*="paidy"]', root).forEach(s=>{ try{ s.remove(); }catch(e){} });
    // 3) 「liquid」ブロックに読み込まれている場合はそのブロックごと隠す
    $$('[data-block-type="liquid"]', root).forEach(b=>{
      const html=(b.innerHTML||'').toLowerCase();
      if (html.includes('paidy')) { try{ b.remove(); }catch(e){ b.style.display='none'; } }
    });
  }

  /** 価格直後に ASK ボタンを追加（Prestigeのホバーを継承） */
  function ensureAskButton(href){
    if (document.querySelector('[data-vn-ask-btn]')) return;
    const priceBlk = $('[data-block-type="price"]') || $(PRICE_CONTAINER_SEL);
    const wrap = document.createElement('div'); wrap.dataset.vnAskBtn=''; wrap.style.margin='1rem 0';

    const btn  = document.createElement('a');
    btn.href = href;
    btn.setAttribute('role','button');
    btn.className = 'button w-full';          // ← Prestigeのホバー/動きを継承
    btn.textContent = '価格はお問い合わせ / ASK'; // ① 文言変更

    wrap.appendChild(btn);

    if (priceBlk && priceBlk.parentElement) priceBlk.parentElement.insertBefore(wrap, priceBlk.nextSibling);
    else (document.querySelector('.product__info, .product__info-container, main, body') || document.body).prepend(wrap);
  }

  /* ===== 商品ページ ===== */
  (function(){
    if (!(IS_PRODUCT && cfg.askOnly)) return;

    const mailtoTo = (cfg.askMailTo || '').trim();
    const targetHref = mailtoTo ? makeMailtoUrl(mailtoTo, cfg.productTitle, cfg.productUrl) : '#';

    replacePriceWithASK(document);
    disableBuying(document, () => { if (targetHref !== '#') location.href = targetHref; });
    hidePaidy(document);                 // ② Paidy 非表示
    ensureAskButton(targetHref);
    uncloack();                          // 初期チラ見え解除

    // 動的復活にも追従
    const mo = new MutationObserver(muts=>{
      let touched=false;
      muts.forEach(m=>{
        if (m.addedNodes) {
          m.addedNodes.forEach(n=>{
            if (n.querySelectorAll && (
              n.matches && (n.matches('[data-block-type="price"], '+BUY_BLOCK_SEL+', [data-block-type="liquid"]') ||
              n.querySelector('[data-block-type="price"]') || n.querySelector(BUY_BLOCK_SEL) || n.querySelector('[data-block-type="liquid"]'))
            )) touched = true;
          });
        }
      });
      if (touched){
        replacePriceWithASK(document);
        disableBuying(document, () => { if (targetHref !== '#') location.href = targetHref; });
        hidePaidy(document);
        ensureAskButton(targetHref);
      }
    });
    mo.observe(document.documentElement, { childList:true, subtree:true });
  })();

  /* ===== コレクション/検索（価格ASK＋クイック追加OFF） ===== */
  (function(){
    if (!(IS_COLLECTION || IS_SEARCH)) return;

    function isAskCard(card){
      const v = (card.getAttribute('data-ask') || '').trim();
      return v === 'true' || v === '1';
    }
    function replacePriceInCard(card){
      const containers = card.querySelectorAll(PRICE_CONTAINER_SEL);
      let done=false;
      containers.forEach(c=>{
        const cls = c.firstElementChild && c.firstElementChild.className || '';
        c.innerHTML=''; const s=document.createElement('span'); s.textContent='ASK'; s.className=(cls||'').toString();
        c.appendChild(s); done=true;
      });
      if (!done) card.querySelectorAll(PRICE_LEAF_SEL).forEach(n=>{ n.textContent='ASK'; });
    }
    function disableQuickAddInCard(card){
      card.addEventListener('click', function(ev){
        const t = ev.target;
        if (!t) return;
        const btn = t.closest && t.closest('.product-card__quick-add-button, [aria-controls^="product-quick-buy"], quick-buy-modal');
        if (btn && card.contains(btn)) { ev.preventDefault(); ev.stopPropagation(); return false; }
      }, true);
      $$(QUICK_ADD_SEL, card).forEach(n=>{ try{ n.remove(); }catch(e){ n.style.display='none'; } });
    }

    const apply = root => {
      root.querySelectorAll('product-card[data-ask], [data-ask]').forEach(card=>{
        if (!isAskCard(card)) return;
        if (card.getAttribute('data-ask-applied') !== '1') {
          replacePriceInCard(card);
          card.setAttribute('data-ask-applied','1');
        }
        disableQuickAddInCard(card);
      });
    };

    apply(document);
    new MutationObserver(muts=>{
      muts.forEach(m=>{
        m.addedNodes && m.addedNodes.forEach(n=>{ if(n.querySelectorAll) apply(n); });
      });
    }).observe(document.documentElement, { childList:true, subtree:true });
  })();

})(window.__ASK_CFG__);
